import { types } from "../utils/types.js";

class Time {
  PRE_LISTEN = 30;

  applicationStartTime = Date.now();
  pending = [];
  _webAudioOffset = 0;
  useContextTime = false;

  _preUpdate = [];
  _postUpdate = [];
  _nextFrame = [];

  currentTime = 0;
  timeDiff = 0;
  _frameCounter = 0;
  frameRate = 0;

  activateContextTime(context) {
    this.webAudioContext = context;
    this._webAudioOffset = Date.now() - this.applicationStartTime - context.currentTime * 1000;
    this.useContextTime = true;
  }

  get webAudioOffset() {
    return this._webAudioOffset;
  }

  get current() {
    return performance.now();
    // return this.useContextTime
    //   ? this.webAudioContext.currentTime * 1000 + this._webAudioOffset
    //   : Date.now() - this.applicationStartTime;
  }

  preUpdate(f) {
    this._preUpdate.push(f);
  }

  postUpdate(f) {
    this._postUpdate.push(f);
  }

  nextFrame(f) {
    this._nextFrame.push(f);
  }

  runUpdate() {
    //frameCounter();
    while (this._preUpdate.length > 0) {
      this._preUpdate.shift()();
    }
    while (this._postUpdate.length > 0) {
      this._postUpdate.shift()();
    }
    while (this._nextFrame.length > 0) {
      this._preUpdate.push(this._nextFrame.shift());
    }
  }

  frameCounter() {
    const previousTime = this.currentTime;
    this.currentTime = this.current;
    this.timeDiff = this.timeDiff + (this.currentTime - previousTime);
    this._frameCounter++;
    if (this._frameCounter === 4) {
      this.frameRate = 1 / (this.timeDiff / 5 / 1000);
      if (this.frameRate < 60) {
        console.error("time", this.frameRate.toFixed(2));
      }
      this.timeDiff = 0;
      this._frameCounter = 0;
    }
  }

  schedule(actionTime, f) {
    const fromNow = actionTime - this.current;
    let id;

    if (fromNow > 0) {
      id = setTimeout(execute.bind(this), fromNow);
      this.pending.push(id);
    } else {
      execute.call(this);
      return;
    }

    return id || 0;

    function execute() {
      this.removeFromPending(id);
      f();
    }
  }

  unschedule(id) {
    clearTimeout(id);
    this.removeFromPending(id);
  }

  clear() {
    for (const id of this.pending) {
      clearTimeout(id);
    }
    this.pending.length = 0;
  }

  removeFromPending(id) {
    this.pending.splice(this.pending.indexOf(id), 1);
  }
}

const time = new Time();

class Scheduler {
  constructor(context, delayedFunction, preListen) {
    delayedFunction = types.isString(delayedFunction) ? context[delayedFunction] : delayedFunction;
    this.delayedFunction = delayedFunction.apply.bind(delayedFunction, context);
    this.preListen = preListen === undefined ? time.PRE_LISTEN : preListen;
    this.pending = [];
  }

  schedule(actionTime, ...arguments_) {
    const when = actionTime - this.preListen;
    const now = time.current;
    let id;

    if (when <= now) {
      id = -1;
      execute.call(this);
    } else {
      id = time.schedule(when, execute.bind(this));
      this.pending.push(id);
      return id;
    }

    function execute() {
      time.removeFromPending(id);
      this.delayedFunction(arguments_);
    }
  }

  clear() {
    for (const id of this.pending) {
      time.unschedule(id);
    }
    this.pending = [];
  }
}

export { Scheduler, Time, time };